export enum DefaultKanbanCategoryNamesE {
  RECENT = 'RECENT',
  WORKFLOW = 'WORKFLOW',
  ATTENDANCE = 'ATTENDANCE',
  FINISHED = 'FINISHED',
  ARCHIVED = 'ARCHIVED',
}
